import { render } from "./honoreeVotingButton.vue?vue&type=template&id=67bab3d6"
import script from "./honoreeVotingButton.vue?vue&type=script&lang=js"
export * from "./honoreeVotingButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__